import React, { useState } from "react";
import { UpdateTransactionStatus } from "../../pages";
import * as yup from "yup";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { TransactionsController } from "../../controllers";

const UpdateTransactionStatusContainer = ({ closeModal, singleTx }) => {
  const [loading, setLoading] = useState(false);
  const validationSchema = () => {
    return yup.object({
      sessionId: yup.string().required("Session Id is required"),
      status: yup.string().required("Status is required"),
      vendor: yup.string("Select Vendor"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      business: singleTx.business._id,
      transactionReference: singleTx.transactionReference,
      sessionId: values.sessionId,
      status: values.status,
      ...(values.status === "PAID" ? { vendor: values.vendor } : ""),
    };

    const { status, errorMessage } =
      await TransactionsController.updateTransactionStatus(payload);

    if (status === constant.Success) {
      MimaToastUtil.success({
        message: "Transaction Status Updated successfully",
      });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return (
    <UpdateTransactionStatus
      validationSchema={validationSchema}
      loading={loading}
      onSubmit={onSubmit}
      closeModal={closeModal}
    />
  );
};

export default UpdateTransactionStatusContainer;
